module.exports = __webpack_public_path__ + "static/media/seemypetcam-1.7716d9a2.png";